define('gameday-index-configurator/src/model/valueObjects/BuildConfig',['require','exports','module','jquery'],function(require, exports, module) {
	// require imports
	var $ = require("jquery");

	// instance variables
	var manifest = {};


	function BuildConfig(props) {
		$.extend(manifest, props);
	}

	BuildConfig.prototype = {
		getManifest: function() {
			return manifest;
		}
	}

	return BuildConfig;
});
